import { useMutation } from "@apollo/client";
import {
  Button,
  ButtonGroup,
  ControlGroup,
  NumericInput,
} from "@blueprintjs/core";
import _, { isEqual } from "lodash";
import { useEffect, useState } from "react";
import {
  ArticlePrice,
  ArticlePriceTier,
  UpdateArticlePriceInput,
} from "../../../../api/schema";
import { valid_number_keys } from "../../../../components/form/builder/OrderPositions";
import { ValuesVariables } from "../../../../components/form/InputForm";
import {
  DeleteArticlePriceMutation,
  DeleteArticlePriceResponse,
  UpdateArticlePriceMutation,
} from "../../helper/graphql";

export const PriceRow = (props: {
  price: ArticlePrice;
  price_tier: ArticlePriceTier | null;
  on_changed: () => void;
}) => {
  const [delete_price_mutation] = useMutation<DeleteArticlePriceResponse>(
    DeleteArticlePriceMutation
  );

  const delete_price = () => {
    console.log(`deleting price`, props.price);

    delete_price_mutation({ variables: { id: props.price.id } }).then((res) => {
      console.log("delete_price_tier", res);
      if (res.data) props.on_changed();
    });
  };

  const [price_state, set_price_state] = useState(props.price);

  // console.log("contrcutor for price row");
  // console.log(props.price, price_state);

  // useEffect(() => {
  //   // console.log("effect on props or price_state");
  //   console.log(props.price, price_state);
  // }, [props.price, price_state]);

  const edited = !_.isEqual(props.price, price_state);

  const [qty_edited, set_qty_edited] = useState(false);
  const [price_edited, set_price_edited] = useState(false);

  useEffect(() => {
    set_qty_edited(!isEqual(props.price.quantity, price_state.quantity));
    set_price_edited(!isEqual(props.price.price, price_state.price));
  }, [price_state, props.price]);

  // const qty_edited = !_.isEqual(props.price.quantity, price_state.quantity);
  // const price_edited = !_.isEqual(props.price.price, price_state.price);

  const qty_exists =
    _.find(
      props.price_tier?.prices || [],
      (p) => p.quantity === price_state.quantity && p.id !== price_state.id
    ) !== undefined;

  const [update_article_price] = useMutation<
    ArticlePrice,
    ValuesVariables<UpdateArticlePriceInput>
  >(UpdateArticlePriceMutation);

  const save_price = () => {
    if (!edited) return;

    update_article_price({
      variables: {
        values: _.pick(price_state, ["id", "price", "quantity"]),
      },
    }).then((res) => {
      // console.log("updated article price", res);
      if (res.data) props.on_changed();
    });
  };

  return (
    <div className="aw_ap_row">
      <ControlGroup>
        <div className="aw_ap_qty">
          <NumericInput
            value={price_state.quantity}
            leftIcon="numerical"
            onValueChange={(e) =>
              set_price_state({ ...price_state, quantity: e })
            }
            min={1}
            fill
            rightElement={
              qty_edited ? (
                <Button
                  icon="eraser"
                  intent="warning"
                  outlined
                  onClick={() =>
                    set_price_state({
                      ...price_state,
                      quantity: props.price.quantity,
                    })
                  }
                />
              ) : undefined
            }
          />
        </div>
        <div className="aw_ap_price">
          <NumericInput
            fill
            value={price_state.price}
            leftIcon="euro"
            allowNumericCharactersOnly={false}
            rightElement={
              price_edited ? (
                <Button
                  icon="eraser"
                  intent="warning"
                  outlined
                  onClick={() =>
                    set_price_state({
                      ...price_state,
                      price: props.price.price,
                    })
                  }
                />
              ) : undefined
            }
            onValueChange={(a, b, c) => {
              if (!isNaN(a)) set_price_state({ ...price_state, price: a });
            }}
            asyncControl
            onBlur={(e) => {
              try {
                const n = parseFloat(
                  (e.target as HTMLInputElement).value.split(",").join(".")
                );
                set_price_state({ ...price_state, price: n });
              } catch {}
            }}
            onKeyDown={(e) => {
              const value = e.currentTarget.value;
              if (
                (e.key === "." || e.key === ",") &&
                (_.indexOf(value, ".") !== -1 || _.indexOf(value, ",") !== -1)
              )
                e.preventDefault();

              if (
                _.indexOf(
                  valid_number_keys.filter((s) => s !== "-"),
                  e.key
                ) === -1
              ) {
                e.preventDefault();
                return;
              }
              if (e.key === "Enter" || e.key === "Tab") {
                try {
                  const n = parseFloat(
                    e.currentTarget.value.split(",").join(".")
                  );
                  set_price_state({ ...price_state, price: n });
                } catch {}
              }
            }}
          />
        </div>
      </ControlGroup>
      <ButtonGroup>
        {edited ? (
          <Button
            intent="primary"
            icon="edit"
            onClick={save_price}
            disabled={qty_exists}
            style={{ display: edited ? undefined : "none" }}
          />
        ) : (
          <></>
        )}

        <Button intent="danger" icon="cross" onClick={delete_price} />
      </ButtonGroup>
    </div>
  );
};
